import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { InputComponentWrapper } from '../../constants';
import { ValidationService } from '../validation.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'conn-phone-number-input',
  templateUrl: './phone-number-input.component.html',
  styleUrls: ['./phone-number-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PhoneNumberInputComponent implements OnInit {
  private validationService = inject(ValidationService);

  @Input() submitted: boolean;
  @Input() inputModel: string;
  @Input() required: boolean;
  @Input() labelName: string;
  @Input() labelOnNewline = false;
  @Input() isReadOnly = false;
  @Output() customBlur: EventEmitter<Event>;
  @Output() modelChanged: EventEmitter<InputComponentWrapper>;
  isValid: boolean;
  environment = environment;

  constructor() {
    this.modelChanged = new EventEmitter<InputComponentWrapper>();
    this.customBlur = new EventEmitter<Event>();
    this.inputModel = '';
    this.isValid = false;
  }

  ngOnInit(): void {
    this.isValid = this.validationService.isPhoneNumberValid(
      this.inputModel,
      this.required,
    );
  }

  /*Let the parent know that data has been changed and the form is potentially ready to be resubmitted*/
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.changeModel(input.value);
  }

  changeModel(changedData: string) {
    const strippedChangedData =
      this.validationService.stripNonNumber(changedData);
    if (changedData !== undefined && strippedChangedData !== this.inputModel) {
      changedData = strippedChangedData;
      this.submitted = false;
      this.inputModel = changedData;
      this.isValid = this.validationService.isPhoneNumberValid(
        changedData,
        this.required,
      );
      this.modelChanged.emit({
        inputText: changedData,
        isValid: this.isValid,
      } as InputComponentWrapper);
    }
  }

  emitBlur() {
    this.submitted = true;
    this.customBlur.emit(new Event('blur'));
  }
}
